import React, { Component, useState } from "react";
import { registerUser, useAuthState, useAuthDispatch } from '../../Context';

function Register(props){
    const [regFirst, setFirst] = useState('');
    const [regLast, setLast] = useState('');
    const [regOrg, setOrg] = useState('');
    const [regEmail, setEmail] = useState('');
    const [regPass, setPassword] = useState('');
    const [regConfirmPass, setConfirmPass] = useState('');
    const [regAddress, setAddress] = useState('');
    const [regPhoneNumber, setPhoneNumber] = useState('');

    const dispatch = useAuthDispatch();
    const { loading, errorMessage } = useAuthState();

    const regUser = async (e) => {
        e.preventDefault();
        try {
            let response = await registerUser(dispatch, {
                "regFirst": regFirst,
                "regLast": regLast,
                "regOrg": regOrg,
                "regEmail": regEmail,
                "regPass": regPass,
                "regConfirmPass": regConfirmPass,
                "regAddress": regAddress,
                "regPhoneNumber": regPhoneNumber
            });
            props.history.push('/');
            if (!response.user) return;

        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="submit-form">
                <div>
                    <h1>Register Page</h1>
                    <form>
                    <div className="form-group">
                        <label htmlFor="title">First Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="regFirst"
                            required
                            value={regFirst}
                            name="regFirst"
                            onChange={(e) => setFirst(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Last Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="regLast"
                            required
                            value={regLast}
                            name="regLast"
                            onChange={(e) => setLast(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Organization</label>
                        <input
                            type="text"
                            className="form-control"
                            id="regOrg"
                            required
                            value={regOrg}
                            name="regOrg"
                            onChange={(e) => setOrg(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Email</label>
                        <input
                            type="text"
                            className="form-control"
                            id="regEmail"
                            required
                            value={regEmail}
                            name="regEmail"
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="regPass"
                            required
                            value={regPass}
                            name="regPass"
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Confirm Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="regConfirmPass"
                            required
                            value={regConfirmPass}
                            name="regConfirmPass"
                            onChange={(e) => setConfirmPass(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Address</label>
                        <input
                            type="text"
                            className="form-control"
                            id="regAddress"
                            required
                            value={regAddress}
                            name="regAddress"
                            onChange={(e) => setAddress(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Phone Number</label>
                        <input
                            type="text"
                            className="form-control"
                            id="regPhoneNumber"
                            required
                            value={regPhoneNumber}
                            name="regPhoneNumber"
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <button onClick={regUser} className="btn btn-success" disabled={loading}>
                        Register
                    </button>
                    </form>
                </div>
        </div>
    )
}

export default Register
